// extracted by mini-css-extract-plugin
export default {"btn__base":"Button_btn__base__wwaDn"};